import { Spinner } from "@blueprintjs/core";
import * as React from "react";
import { useParams } from "react-router";

import {
  AffixRequestApi,
  EPlatform,
  ERequestState,
  KennelOwnershipChangeRequestDto,
  RequestDto,
} from "../../../../api";
import { PageContainer } from "../../../../components";
import { useApiService, useCrudApi, useTl } from "../../../../hooks";
import { ETLCodes } from "../../../../locales";
import { DrupalRequestResume } from "../../../common";
import { DrupalFieldSet } from "../../../common/DurpalFieldSet";
import { EDrupalRoutes } from "../../../EDrupalRoutes";
import { DrupalKennelOwnershipChangeRequestForm } from "./DrupalKennelOwnershipChangeRequestForm";

export interface IDrupalKennelOwnershipChangeRequestPageProps {}

export const DrupalKennelOwnershipChangeRequestPage: React.FunctionComponent<IDrupalKennelOwnershipChangeRequestPageProps> = () => {
  const { id } = useParams<{ id: string }>();

  const kennelOwnershipChangeRequestId = React.useMemo(() => +id, [id]);

  const { t } = useTl();
  const api = useApiService(AffixRequestApi);

  // TODO-CRR : saving is used, but not saveItem???
  const { data, loading, saving } = useCrudApi<KennelOwnershipChangeRequestDto>(
    React.useMemo(
      () => ({
        getApiFn: (apiId = kennelOwnershipChangeRequestId) =>
          apiId > 0
            ? api.getKennelOwnershipChangeRequest(apiId)
            : new KennelOwnershipChangeRequestDto({
                request: new RequestDto({
                  requestDate: new Date(),
                  status: ERequestState.REQUESTED,
                  platform: EPlatform.PORTAL,
                }),
              }).toJSON(),
        saveApiFn: (d: KennelOwnershipChangeRequestDto) =>
          api.saveKennelImportRequest(KennelOwnershipChangeRequestDto.fromJS({ ...d, isPortal: true })),
        onSavedRoute: (d) =>
          d.request.status === ERequestState.BILLED
            ? `${EDrupalRoutes.kennelOwnershipChangeRequest}/${d.kennelOwnershipChangeRequestId}`
            : EDrupalRoutes.requestList,
        deleteApiFn: () => {},
      }),
      [api, kennelOwnershipChangeRequestId]
    ),
    [kennelOwnershipChangeRequestId]
  );

  return loading ? (
    <Spinner />
  ) : (
    <PageContainer>
      <DrupalFieldSet title={`${t(ETLCodes.Payment)}: ${t(ETLCodes.KennelOwnershipChangeRequest)}`}>
        <div>
          {saving ? (
            <Spinner />
          ) : (
            <DrupalRequestResume
              requestForm={
                <DrupalKennelOwnershipChangeRequestForm
                  kennelOwnershipChangeRequestId={kennelOwnershipChangeRequestId}
                  initialdata={data}
                  loading={saving}
                />
              }
              requestDto={data?.request}
              bill={null}
            />
          )}
        </div>
      </DrupalFieldSet>
    </PageContainer>
  );
};
